import React from "react";
import parse from "html-react-parser";
import { SectionText } from "../../components/SectionText/SectionText";
import { Icon } from "../../components/Icon/Icon";
import { Button } from "../../components/Button/Button";
import { LinkText } from "../../components/LinkText/LinkText";
import { getUrl } from "../../helpers/Pipes";

export const Modal = ({
  name,
  id,
  title,
  source,
  description,
  typeDocument,
  buttonModalOnClick,
  closeModalOnClick,
  isModalActive,
  isCardSigned,
  noHeader,
}) => {
  const _active = isModalActive ? "active" : "";

  function renderContent(name) {
    switch (name) {
      case "modalExit":
        return (
          <>
            <Icon setViewBox="yes" name="money" />
            {id === "modalExitPre" ? (
              <>
                <SectionText
                  hideText="no"
                  titleLabel="Sei sicuro di voler abbandonare la tua richiesta di prestito?"
                  textLabel="Oltre 10.000.000 di clienti hanno scelto un prestito Compass. Se vieni in filiale avrai più possibilità di ottenere un prestito e nel migliore dei casi basta un giorno!"
                  customClasses="mBottom5x"
                />

                <Button
                  color="red"
                  label="Fissa un appuntamento"
                  uppercase="yes"
                  withIcon="no"
                  customClasses="mBottom4x"
                  onClick={() => {
                    window.location.href = getUrl("fa");
                  }}
                />

                <LinkText
                  type="link-only"
                  linkText="Continua la compilazione"
                  customClasses="closeModal"
                  onClick={closeModalOnClick}
                />
              </>
            ) : (
              ""
            )}

            {id === "modalExitPost" ? (
              <>
                <SectionText
                  hideText="no"
                  titleLabel="Sei sicuro di voler abbandonare la tua richiesta di prestito?"
                  textLabel={parse(
                    "Potrai riprendere la compilazione in qualunque momento utilizzando il link che ti abbiamo inviato via email.<br/>Riprenderai dove hai lasciato."
                  )}
                  customClasses="mBottom5x"
                />

                <Button
                  color="red"
                  label="Continua la compilazione"
                  uppercase="yes"
                  withIcon="no"
                  customClasses="mBottom4x closeModal"
                  onClick={closeModalOnClick}
                />
                <LinkText type="link-only" linkText="Fissa un appuntamento" />
              </>
            ) : (
              ""
            )}
          </>
        );

      case "moreInfo":
        return (
          <>
            <p className="moreInfo-text">
              I valori dei tassi (TAN e TAEG) rimarranno espressi come
              intervallo tra minimo e massimo, finchè non avremo preso in carico
              e valutato la tua richiesta. <br />
              Per personalizzare la tua richiesta di prestito ti chiediamo
              quindi di fornirci maggiori informazioni.
            </p>

            <Button
              color="red"
              label="Ok, ho capito"
              uppercase="yes"
              withIcon="no"
              customClasses=""
              onClick={closeModalOnClick}
            />
          </>
        );

      default:
        return <p>{description}</p>;
    }
  }

  return (
    <>
      <div
        className={["modal", name, _active].join(" ")}
        id={id}
        onClick={closeModalOnClick}
        aria-hidden={isModalActive ? false : true}
      >
        <div className="modal-dialog">
          <div
            className="modal-content"
            onClick={(event) => event.stopPropagation()}
          >
            {!noHeader && (
              <div className="modal-header">
                {name === "camera" ? (
                  <a href="/" className="header-left">
                    <Icon setViewBow="yes" name="" />
                  </a>
                ) : (
                  ""
                )}

                <h5 className="modal-title">{title}</h5>
                
                {/* changed figure to button for semantic and accessibility */}
                <button
                  className="close"
                  onClick={closeModalOnClick}
                  aria-label="Close modal"
                >
                  <Icon setViewBox="yes" name="close" />
                </button>
              </div>
            )}

            <div className="modal-body" id={id}>
              {renderContent(name)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
